import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import LoadingPage from 'src/components/LoadingPage';
import useProjectAccess, {
  ProjectAccessPermission,
} from 'src/hooks/useProjectAccess';
import { RootState } from 'src/store';

interface RequireAccessProps {
  permission: ProjectAccessPermission;
  children: ReactNode;
}

const RequireAccess: FC<RequireAccessProps> = ({ permission, children }) => {
  const { loading, data } = useSelector(
    (globalState: RootState) => globalState.projectRetainer
  );
  const access = useProjectAccess();

  if (loading && !data) {
    return <LoadingPage />;
  }

  if (!access[permission]) {
    return <Navigate replace to="/dashboard" />;
  }

  return <>{children}</>;
};

export default RequireAccess;
